'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCurrentChannelAction = undefined;

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setCurrentChannelAction = exports.setCurrentChannelAction = (0, _reduxActions.createAction)(ActionTypes.SET_CURRENT_CHANNEL, function (channel) {
  return { channel: channel };
});


//////////////////
// WEBPACK FOOTER
// ./js/actions/ConversationsActions/setCurrentChannelAction.js
// module id = 620
// module chunks = 2 3